import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { EditModeComponent } from './edit-mode.component';

@NgModule({
    imports: [SharedModule],
    declarations: [EditModeComponent],
    entryComponents: [EditModeComponent],
    exports: [EditModeComponent]
})
export class EditModeModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/edit-mode/edit-mode.module.ts